const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/tracking.ts';
import Imm from 'immutable';
import { TrackingData, TrackingState } from 'App/defs/trackingDefs';
import { IActionHandlersMap, makeReducer, ReducerState } from '@cistec/common_web/defs/actionTypes';
import {
    ACTION_TYPE_NATIVE_PATAPP_TRACKING_DENIED_OR_BLOCKED,
    ACTION_TYPE_NATIVE_PATAPP_TRACKING_GRANTED,
    ACTION_TYPE_NATIVE_PATAPP_TRACKING_NO_PERMISSION_AVAILABLE,
} from 'App/actions/patAppNative';
import {
    ACTION_TYPE_PATAPP_TRACKING_AGREE,
    ACTION_TYPE_PATAPP_TRACKING_DISAGREE,
    ACTION_TYPE_PATAPP_TRACKING_FROM_STORAGE,
} from 'App/actions/tracking';
import { PatAppStoreState } from './setup/rootReducer';

const emptyMap = Imm.Map<string, any>();

const initialState = Imm.fromJS({
    state: TrackingState.INITIAL,
});
const stateDisagree = Imm.fromJS({
    state: TrackingState.DISAGREE,
});
const stateAgree = Imm.fromJS({
    state: TrackingState.AGREE,
});
const stateNoPermissionAvailable = Imm.fromJS({
    state: TrackingState.NO_PERMISSION_AVAILABLE,
});

const handleSessionStorage = (state: any) => {
    localStorage.setItem(TrackingData, state.get('state'));
    return state;
};

const handlers: IActionHandlersMap = {
    [ACTION_TYPE_PATAPP_TRACKING_AGREE]: () => handleSessionStorage(stateAgree),
    [ACTION_TYPE_PATAPP_TRACKING_DISAGREE]: () => handleSessionStorage(stateDisagree),
    [ACTION_TYPE_PATAPP_TRACKING_FROM_STORAGE]: (_state: any, action: any) => {
        return handleSessionStorage(
            Imm.fromJS({
                state: action.payload,
            })
        );
    },
    [ACTION_TYPE_NATIVE_PATAPP_TRACKING_GRANTED]: () => handleSessionStorage(stateAgree),
    [ACTION_TYPE_NATIVE_PATAPP_TRACKING_DENIED_OR_BLOCKED]: () => handleSessionStorage(stateDisagree),
    [ACTION_TYPE_NATIVE_PATAPP_TRACKING_NO_PERMISSION_AVAILABLE]: (state: ReducerState) => {
        if (state.get('state') !== TrackingState.AGREE && state.get('state') !== TrackingState.DISAGREE) {
            return stateNoPermissionAvailable;
        } else {
            return state;
        }
    },
};

export const trackingReducer = makeReducer(handlers, initialState);

export const trackingSelector = (state: PatAppStoreState): Imm.Map<string, any> =>
    state.tracking.get('state') || emptyMap;
